import firebase from "firebase/app"
import "firebase/firestore"

export type Deck = { title: string; description: string; cover: string; logo: string }
type Metrics = { deckCount: number; cardCount: number; freeCount: number }

const firebaseConfig = {
  apiKey: "AIzaSyAdDHMULVk5iikJwfqNUfWYeDhJo-LqD4I",
  authDomain: "inspect-and-adapt.firebaseapp.com",
  projectId: "inspect-and-adapt",
}

const defaultMetrics: Metrics = {
  deckCount: 0,
  cardCount: 0,
  freeCount: 0,
}

class Firebase {
  database: firebase.firestore.Firestore

  constructor() {
    firebase.initializeApp(firebaseConfig)
    this.database = firebase.firestore()
  }

  fetchMetrics = async () => {
    const data: Metrics = await this.database
      .collection("public")
      .doc("metrics")
      .get()
      .then(doc => {
        const docData = doc.data()
        const deckCount = docData?.deckCount ?? 0
        const cardCount = docData?.cardCount ?? 0
        const freeCount = docData?.freeCount ?? 0
        return { deckCount, cardCount, freeCount }
      })
      .catch(() => defaultMetrics)
    return data
  }

  fetchDecks = async () => {
    const decks: Deck[] = await this.database
      .collection("packs")
      .where("isLive", "==", true)
      .get()
      .then(snapshot => {
        let decks: Deck[] = []
        snapshot.forEach(doc => {
          const data = doc.data()
          decks.push({
            title: data?.title ?? "",
            description: data?.description ?? "",
            cover: data?.coverImageURL ?? "",
            logo: data?.logoImageURL ?? "",
          })
        })
        return decks
      })
      .catch(() => [])
    return decks
  }
}

const instance = new Firebase()
Object.freeze(instance)

export default instance
